export default __webpack_public_path__ + "static/media/FooterImages-thd_logo.7f8011a0.jpg";